<template>
	<div class="animated fadeIn">
		<div class="row pageinfo">
			<b-col lg="6">
				<!--Display Trash or Normal Table View-->
				<h2>Invoice - {{this.subTitle}}</h2>
			</b-col>
			<!--Gear Icon-->
			<b-col lg="6">
				<!-- <b-btn class="pull-right" v-b-popover.hover.top="'Select Datapoints'" variant="info" @click="configTable = true"><i class="fa fa-cog"></i></b-btn> -->
				
				<b-dropdown :disabled="edit" class="pull-right" right variant="info" no-caret>
					<template slot="button-content">
						<i class="fa fa-cog"></i>
					</template>
					<b-dropdown-item @click="editTerminal">Edit</b-dropdown-item>
					<b-dropdown-item @click="deleteTerminal">Delete</b-dropdown-item>
				</b-dropdown>
				<b-btn v-if="role !='analyst' && !edit" class="pull-right" variant="info" @click="send_click()"><i class="fa fa-send"></i></b-btn>				
				<b-btn class="pull-right ml5" v-b-popover.hover.top="'Select Datapoints'" variant="info" @click="openSelectColumns()"><i class="fa fa-bullseye"></i></b-btn>
			</b-col>
		</div>

		<div>
			<b-card v-if="loadingData">
				<b-col cols="12" sm="12" md="12" lg="12">
					<p class="text-center">
						<i class="fa fa-refresh fa-lg mt-4 fa-spin"></i><br>Loading data...
					</p>
				</b-col>
			</b-card>
			<div v-else>
				<b-card v-if="found">
					<b-row>
                        <!-- @input="selects_trucking_company()" -->
						<b-col md="8">
                            <b-form-group v-if="role =='super_admin'" :label-cols="4" horizontal label="Trucking Company" label-for="tc">
                                <b-form-input v-if="!edit" class="plaintext-input" plaintext id="tc" v-model="model.trucking_company_name" type="text"></b-form-input>
                                <b-form-select v-else :disabled="trucking_companies.length==0" value-field="id" text-field="trucking_company_name" id="tc" v-model="model.trucking_company_id" :options="trucking_companies" @input="selects_trucking_company()" />
                            </b-form-group>

                            <b-form-group :label-cols="4" horizontal label="Energy Company" label-for="tc">
                                <b-form-input v-if="!edit" class="plaintext-input" plaintext id="tc" v-model="model.energy_company_name" type="text"></b-form-input>
                                <b-form-select v-else :disabled="energy_companies.length==0" value-field="id" text-field="energy_company_name" id="tc" v-model="model.energy_company_id" :options="energy_companies"  />
                            </b-form-group>

                            <b-form-group :label-cols="4" horizontal label="Invoice Ref" label-for="invoice_ref">
                                <b-form-input v-if="!edit" class="plaintext-input" plaintext id="invoice_ref" v-model="model.invoice_ref"  type="text"></b-form-input>
                                <b-form-input v-else id="invoice_ref" v-model="model.invoice_ref"  type="text"></b-form-input>
                            </b-form-group>

                            <b-form-group :label-cols="4" horizontal label="Cost Code/PO" label-for="cost_code">
                                <b-form-input v-if="!edit" class="plaintext-input" plaintext id="cost_code" v-model="model.cost_code"  type="text"></b-form-input>
                                <b-form-input v-else id="cost_code" v-model="model.cost_code"  type="text"></b-form-input>
                            </b-form-group>

							<b-form-group :label-cols="4" horizontal label="Date" label-for="date">
                                <b-form-input v-if="!edit" class="plaintext-input" plaintext id="date" v-model="model.date"  type="text" readonly></b-form-input>
                                <b-form-input v-else id="date" v-model="model.date"  type="date" :readonly="!edit"></b-form-input>
                            </b-form-group>
							<b-form-group :label-cols="4" horizontal label="Surcharge Value" label-for="surcharge">
								<b-form-input id="surcharge" v-if="!edit" class="plaintext-input" plaintext v-model="model.surcharge" type="text"></b-form-input>
								<b-form-input id="surcharge" v-else v-model="model.surcharge" type="text" placeholder="0.00" @keydown.native="myOnlyNumber($event, 'surcharge')" @blur.native="inputBlur('surcharge')"></b-form-input>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col md="8">
							<b-form-group vertical label="" label-for="summary">
								<b-table 
									striped 
									show-empty 
									empty-text="No Summary"
									:fields = fields1 
									:items="model.summary" 
									stacked="sm" 
									outlined 
									small
									bordered
            						hover 
									@row-clicked="rowClicked"
								>
								</b-table>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row >
						<b-col cols="1"  md="1">
							<div>
								<span style="font-weight: bold">Sub-Total</span>
							</div>
						</b-col>
						<b-col cols="4"  md="4">
						</b-col>
						<b-col cols="1"  md="1" class="p-1 text-center">
								<div>
									<span style="font-weight: bold">{{ model.rate_avg }}</span>
									
								</div>
						</b-col>
						<b-col cols="1" md="1" class="p-1 text-center">
								<div >
									<span style="font-weight: bold">{{ model.volume_avg }}</span>
									
								</div>						
						</b-col>
						<b-col cols="1" md="1" class="p-1 text-left">
								<div >
									<span style="font-weight: bold">{{ model.s_total_avg }}</span>
									
								</div>						
						</b-col>
					</b-row>
					<b-row>
						<b-col md="12">
							<h3></h3>
						</b-col>
					</b-row>
					<b-row>
						<b-col md="12">
							<h5>Hauls</h5>
							<b-form-group vertical label="" label-for="hauls">
								<b-table 
									striped 
									show-empty 
									empty-text="No Hauls"
									:fields = fields 
									:items="model.hauls" 
									stacked="sm" 
									outlined 
									small
									bordered
            						hover 
									@row-clicked="rowClicked"
								>
								</b-table>
							</b-form-group>
						</b-col>
					
					</b-row>

					<b-row>
						<b-col md="12">
						<div slot="footer" v-show="edit">
							<b-button @click="updateTerminal" size="sm" variant="primary"><i class="fa fa-edit"></i> Update</b-button>
							<b-button @click="editTerminal" size="sm"><i class="fa fa-ban"></i> Cancel</b-button>
						</div>
						</b-col>
					</b-row>
				</b-card>
				<b-row v-else>
					<b-col cols="12" sm="12" md="12" lg="12">
						<br>
						<p class="text-center text-danger">
							<i class="icon fa-lg icon-puzzle"></i><br>{{notFoundMessage}}
						</p>
					</b-col>
				</b-row>
			</div>
		</div>
		<b-modal title="Columns to Display" v-model="configTable" ok-variant="primary">

      <b-container class="bv-example-row">
        <b-row>
          <b-col md="6">
            <b-form-checkbox-group stacked id="basicCheckboxes" name="Checkboxes" :plain="true" :checked="selectedItems">
				<b-form-checkbox :disabled="shouldBeDisabled('ticket')" value="ticket" @change="actionField('ticket', 'Ticket #',1)">Ticket #</b-form-checkbox>
 				<b-form-checkbox :disabled="shouldBeDisabled('haul_start_date')" value="haul_start_date" @change="actionField('haul_start_date', 'Start Date', 2)">Start Date</b-form-checkbox>
              	<b-form-checkbox :disabled="shouldBeDisabled('load_location')" value="load_location" @change="actionField('load_location', 'Load', 3)">Load</b-form-checkbox>
              	<b-form-checkbox :disabled="shouldBeDisabled('unload_location')" value="unload_location" @change="actionField('unload_location', 'Unload', 4)">Unload</b-form-checkbox>
				
			  	<b-form-checkbox :disabled="shouldBeDisabled('terminal_boss')" value="terminal_boss" @change="actionField('terminal_boss', 'Terminal Boss Ticket',5)">Terminal Boss Ticket</b-form-checkbox>
			  	<b-form-checkbox :disabled="shouldBeDisabled('volume')" value="volume" @change="actionField('volume','Volume',6)">Volume</b-form-checkbox>
				<b-form-checkbox :disabled="shouldBeDisabled('bsw')" value="bsw" @change="actionField('bsw', 'BS&W', 7)">BS&W</b-form-checkbox> 
				<b-form-checkbox :disabled="shouldBeDisabled('fluid_type')" value="fluid_type" @change="actionField('fluid_type','Fluid Type', 8)">Fluid Type</b-form-checkbox>			  
				<b-form-checkbox :disabled="shouldBeDisabled('truck_unit')" value="truck_unit" @change="actionField('truck_unit','Truck Unit',9)">Truck Unit</b-form-checkbox>
				<b-form-checkbox :disabled="shouldBeDisabled('trailer')" value="trailer" @change="actionField('trailer','Trailer',10)">Trailer</b-form-checkbox> 			               
            </b-form-checkbox-group>
          </b-col>
          <b-col md="6">
			  	<b-form-checkbox-group stacked id="basicCheckboxes" name="Checkboxes" :plain="true" :checked="selectedItems">

					<b-form-checkbox :disabled="shouldBeDisabled('rate')" value="rate" @change="actionField('rate','Rate', 11)">Rate</b-form-checkbox> 			  
					<b-form-checkbox :disabled="shouldBeDisabled('stb')" value="stb" @change="actionField('stb', 'STB Time', 12)">STB Time</b-form-checkbox>		  
					<b-form-checkbox :disabled="shouldBeDisabled('cost_stb')" value="cost_stb" @change="actionField('cost_stb','STB Cost', 13)">STB Cost</b-form-checkbox>
					<b-form-checkbox :disabled="shouldBeDisabled('justification')" value="justification" @change="actionField('justification','Justification', 14)">Justification</b-form-checkbox>

					<b-form-checkbox :disabled="shouldBeDisabled('fluid_subtotal_cost')" value="fluid_subtotal_cost" @change="actionField('fluid_subtotal_cost','Fluid Subtotal Cost', 15)">Fluid Subtotal Cost</b-form-checkbox>                                 
					<b-form-checkbox :disabled="shouldBeDisabled('fluid_gst')" value="fluid_gst" @change="actionField('fluid_gst','Fluid GST', 16)">Fluid GST</b-form-checkbox>                                 
					<b-form-checkbox :disabled="shouldBeDisabled('fluid_gst_subtotal')" value="fluid_gst_subtotal" @change="actionField('fluid_gst_subtotal','Fluid Total', 17)">Fluid Total</b-form-checkbox> 

					<b-form-checkbox :disabled="shouldBeDisabled('wait_time_cost_subtotal')" value="wait_time_cost_subtotal" @change="actionField('wait_time_cost_subtotal','Wait Time Cost Subtotal', 18)">Wait Time Cost Subtotal</b-form-checkbox>                                 
					<b-form-checkbox :disabled="shouldBeDisabled('wait_time_gst')" value="wait_time_gst" @change="actionField('wait_time_gst','Wait Time GST', 19)">Wait Time GST</b-form-checkbox>                                 
					<b-form-checkbox :disabled="shouldBeDisabled('wait_time_gst_subtotal')" value="wait_time_gst_subtotal" @change="actionField('wait_time_gst_subtotal','Wait Time GST Subtotal', 20)">Wait Time GST Subtotal</b-form-checkbox> 
				</b-form-checkbox-group>
          </b-col>
        </b-row>
      </b-container>
      <!-- </b-form-checkbox-group> -->

      <div slot="modal-footer" class="w-100">
        <b-btn size="md" class="float-left" variant="secondary" @click="configTable=false">
          Cancel
        </b-btn>

        <b-btn size="md" class="float-right" variant="primary" @click="saveSelectedColumns()">
          Save
        </b-btn>
      </div>

    </b-modal>
	</div>
</template>

<script>
	import invoices_service from './invoices_service'
	import haul_service from '../hauls/haul_service'
	export default {
		name: 'Invoice',
		created: function() {
			this.$root.$on('haul_edit', () => {
        this.getTerminalData()
      });
			this.getTerminalData()
		},
		props: {
			id: {
                type        : String,
                default     : 0
			}
		},
		data() {
			return {
				subTitle        : '',
				edit            : false,
				found           : false,
				notFoundMessage : 'Not found',
				model           : {
                    id                      : null,
                    energy_company_id       : null,
                    trucking_company_id     : null,
                    energy_company_name     : '',
                    trucking_company_name   : '',
                    invoice_ref             : '',
					cost_code				: '',
					date                    : null,
					hauls                   : [],
					summary 				: [],
					volume_avg				: 0,
					rate_avg				: 0,
					s_total_avg				: 0,
					surcharge               : '',
				},
				updateData      : null,
				originalData    : null,
                loadingData     : true,
                terminalId      : null,
                role            : '',
                trucking_companies : [],
				energy_companies : [],
				fields			: [ 
									{
										key: 'ticket',
										label: 'Ticket #',
										sortable: true
									},
									{
										key: 'haul_start_date',
										label: 'Start Date',
										sortable: true,
										formatter:(value) => { return moment(value).format("MMM DD, YYYY") }
									},
									{
										key: 'unload_location',
										label: 'Unload',
										sortable: true,
									}, 
									{
										key: 'load_location',
										label: 'Load',
										sortable: false,
									}, 
									{
										key: 'volume',
										label: 'Volume',
										sortable: true,
										formatter: (value) => { if (this.bbll==true){
																	value = Number(parseFloat(value).toFixed(2)*6.289814).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})+' bbl'
																} else {
																	value = Number(parseFloat(value).toFixed(2)).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})+' m³'
																}; return value }
									},
									{
										key: 'bsw',
										label: 'BS&W (%)',
										sortable: false,
										formatter: (value) => { return  parseFloat(value).toFixed(2) }
									}, 
								],
				fields1			: [ 
									{
										key: 'load_location',
										label: 'Well Description',
										sortable: false,
									}, 
									{
										key: 'unload_location',
										label: 'Delivery Point',
										sortable: false,
									}, 
									{
										key: 'fluid_type',
										label: 'Fluid',
										sortable: false,
									}, 
									{
										key: 'truck_type',
										label: 'Truck Type',
										sortable: false,
									}, 
									{
										key: 'cost_code',
										label: 'Cost Center',
										sortable: false,
									}, 
									{
										key: 'rate',
										label: 'Rate($/m³)',
										sortable: false,
									}, 
									{
										key: 'volume',
										label: 'Volume',
										sortable: false,
										formatter: (value) => { if (this.bbll==true){
																	value = Number(parseFloat(value).toFixed(2)*6.289814).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})
																} else {
																	value = Number(parseFloat(value).toFixed(2)).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})
																}; return value }
									},
									{
										key: 's_total',
										label: 'Sub-Total',
										sortable: false,
									}, 
								],
				// 'haul_start_date','load_location','unload_location','ticket','terminal_boss','volume','bsw','fluid_type','truck_unit','trailer','rate','stb','stb_cost','justification','fluid_subtotal_cost','fluid_gst','fluid_gst_subtotal', 'wait_time_cost_subtotal','wait_time_gst','wait_time_gst_subtotal'
				tempFields 		: [],
				fieldsSelected     : 7,
        		maxFieldsSelected  : 20,
				configTable        : false,
				bbll               :false,
				selectedItems             : [
											'haul_id',
											'haul_start_date',
											'load_location',
											'unload_location',
											'ticket',									
											'volume',
											'bsw',
											],
				surcharge                   : '',
			}
		},
		methods: {
			editTerminal() {
				if (this.edit) {
					this.edit = false
					this.restoreOriginalData()
				} else {
					this.setupFields()
					this.edit = true
				}
			},
			restoreOriginalData() {
				let model = {
					...this.originalData,
				}
				this.model = model
			},
			setupFields() {
                if (this.role =='super_admin') {   
                    let temp = this.model.energy_company_id  
                    this.selects_trucking_company()
                    this.model.energy_company_id = temp
                }
			},
			getTerminalData() {
				invoices_service.getBy(this.id)
					.then(data => {
						if (data.status == 'success') {
							this.originalData   = data.invoice
							this.terminalId     = this.id
							this.loadingData    = false
							this.found          = true
							this.restoreOriginalData()	
                            this.subTitle               = this.originalData.trucking_company_name
                            this.trucking_companies = data.update_data.company
							this.role = data.role
							if (this.role === 'trucking_company_admin' || this.role === 'trucking_operational_manager') {  
								let trucking_companies          = this.trucking_companies								  
								this.energy_companies       	= trucking_companies[0].energy_companies
                    			//this.model.energy_company_id    = null
								this.model.trucking_company_id  = trucking_companies[0].id
                    		}  
						}else {
                            this.$swal(data.status, data.message, data.status)
                            this.loadingData = false
                            return
                        }
					})
					.catch(error => {
						this.$swal('Error', 'Server not response. ' + error, 'error')
						this.loadingData = false
					})
			},
			okToUpdate() {

          		if (this.role=="super_admin") {
            		if (this.model.trucking_company_id === undefined || this.model.trucking_company_id == null) {
              			this.$swal('Alert!', 'Trucking Company not selected', 'warning')
              			return false
            		}
          		}

				if (this.model.energy_company_id  === undefined || this.model.energy_company_id === null) {
					this.$swal('Alert!', 'Select Energy Company ID', 'warning')
					return false
				} else if (this.model.invoice_ref === '' || this.model.invoice_ref === undefined) {
					this.$swal('Alert!', 'Please, Enter Invoice Ref', 'warning')
					return false
				} else if (this.model.cost_code === '' || this.model.cost_code === undefined) {
					this.$swal('Alert!', 'Please, Enter Cost Code', 'warning')
					return false
				} else	if(this.model.date === undefined || this.model.date == null) {
					this.$swal('Alert!', 'Please, Enter Date', 'warning')
					return false
          		} else if (this.model.surcharge === undefined || this.model.surcharge.length == 0) {
					this.$swal('Alert!', 'Surcharge value can not be empty', 'warning')
					return false
				}
				return true
			},
      		updateTerminal () {
                if (!this.okToUpdate()) {
					return
                }
				invoices_service.update(this.terminalId, this.model)
					.then((data) => {
						this.$swal(data[0], data[1], data[0])
							.then((result) => {
								this.getTerminalData()
							})
					})
					.catch(error => {
						this.$swal('Error', 'Server not response. ' + error, 'error')
					})
					this.edit=false
			},
			deleteTerminal(item) {
				this.$swal({
					title: 'Please, confirm',
					text: "Are you sure to delete this Invoice for " + this.model.invoice_ref + " ?",
					type: 'question',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Yes',
					reverseButtons: true
				}).then((result) => {
					if (result.value) {
						invoices_service.delete(this.terminalId)
							.then(data => {
								this.$swal(data[0], data[1], data[0])
								if (data[0] == 'success') {
									this.$router.replace('/invoices')
								}
							})
							.catch(error => {
								this.$swal('Error', 'Server not response. ' + error, 'error')
							})
					}
				})
            },
            selects_trucking_company() {
                let trucking_companies              = this.trucking_companies
                this.energy_company                 = []
                let trucking_company_index = trucking_companies.map(o => o.id).indexOf(this.model.trucking_company_id)
                if (trucking_company_index > -1) {
                    this.energy_companies       = trucking_companies[trucking_company_index].energy_companies
                    this.model.energy_company_id    = null
                }
			},
			openSelectColumns() {
				this.tempFields = [...this.fields]
				this.configTable = true
			  },
			rowClicked(row, index, e) {
				e.preventDefault()
				let to_popup = {'id':row.haul_id,'haul_invoice':true,'edit':this.id}
				this.$root.$emit('openPopup', to_popup);
			},
			send_click() {
				this.okToSend()
				let column = this.fields.map((item) => {
                            return item.key  
                          })
        		let send_invoice = {
          							"energy_company_id"		: this.model.energy_company_id,
									"trucking_company_id"	: this.model.trucking_company_id,
									"invoice_id"			: this.terminalId,
									"column"                : column,
									}
				invoices_service.send_invoice(send_invoice)
					.then(data => {
					if (data.status == 'success') {
						this.$swal(data.status, data.message, data.status)
					}
					else {
						this.$swal(data.status, data.message, data.status)
						return
					}
					})
					.catch(error => {
					Vue.swal('Error', 'Server not response. ' + error, 'error')
					})
				},
			okToSend() {

				if (this.model.trucking_company_id === undefined || this.model.trucking_company_id == null) {
					this.$swal('Alert!', 'Trucking Company not selected', 'warning')
					return false
				} else if (this.model.energy_company_id  === undefined || this.model.energy_company_id === null) {
					this.$swal('Alert!', 'Select Energy Company ID', 'warning')
					return false
				} else if (this.model.invoice_ref === '' || this.model.invoice_ref === undefined) {
					this.$swal('Alert!', 'Please, Enter Invoice Ref', 'warning')
					return false
				} 
				return true
			},
			shouldBeDisabled(option) {
        		return (this.fieldsSelected >= this.maxFieldsSelected) && this.tempFields.map(o => o.key).indexOf(option) == -1
      		},
      		actionField(option, label, position) {

				var fieldsLength = this.tempFields.length
				var fieldIsActive = false
				for (var i = 0; i <= fieldsLength; i++) {
				fieldIsActive = true
				try {
					if (this.tempFields[i].key === option || this.tempFields[i] === option) {
					this.tempFields.splice(i, 1)
					fieldIsActive = false
					break
					}
				} catch (err) {

					if (option=='haul_start_date') {
					option = {
						key: option,
						label: label,
						sortable: true,
						formatter: (value) => { return moment(value).format("MMM DD, YYYY") }
					}
					} else {
						option = {
						key: option,
						label: label,
						sortable: true
						}
					}
					this.tempFields.splice(position, 0, option)
				}
				}
				this.fieldsSelected = this.tempFields.length
			},
			saveSelectedColumns() {
				this.fields = [...this.tempFields]
				this.configTable = false
				/* this.filter_by.column = this.fields.map(item =>  item.key )
				haul_service.saveSelectedColumns(this.fields)
				.then((data) => {
					Vue.swal(data[0], data[1], data[0])
					.then((result) => {
						if (data[0] == 'success') {
						this.getAll()
						}
					}) 
				})  */
			},
			inputBlur(variableName) {
				let variableValue = this.model[variableName]
				if (variableValue.length == 0) {
					this.model[variableName] = "0.00"
				} else {
					let tempValue = variableValue.split(".")
					if (tempValue.length == 1) {
					this.model[variableName] = String(variableValue) + ".00"
					} else if (tempValue.length == 2) {
					this.model[variableName] = String(tempValue[0]) + "." + (String(tempValue[1]) + "00").slice(0, 2)
					}
				}
			},
			myOnlyNumber(evt, variableName) {
				let dotPosition = this.model[variableName].indexOf(".")
				let hasDot = dotPosition > -1
				let length = this.model[variableName].length
				this.isNumber(evt, hasDot, dotPosition, length)
			},
			isNumber: function(evt, hasDot, dotPosition, length) {

				evt = (evt) ? evt : window.event;
				var charCode = (evt.which) ? evt.which : evt.keyCode;
				if (charCode <= 31 || charCode == 37 || charCode == 39 || (charCode >= 96 && charCode <= 105) || ((charCode >= 48 && charCode <= 57) || charCode === 46 || charCode === 19 || (!hasDot && charCode == 190)|| (!hasDot && charCode == 110))) {
					let selectionStart = evt.target.selectionStart;
					let selectionEnd = evt.target.selectionEnd;
					if ((hasDot && (selectionEnd > dotPosition && selectionStart > dotPosition && selectionEnd == selectionStart) && length - 2 > dotPosition) && charCode > 31 && (charCode != 37 && charCode != 39)) {
					evt.preventDefault();
					} else {
					return true
					}
				} else {
					evt.preventDefault();
				}
			},
		}
	}
</script>



// WEBPACK FOOTER //
// src/views/invoices/invoice.vue